module.exports = __webpack_public_path__ + "static/img/img01.eef6d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img01.png
// module id = Zk4q
// module chunks = 1